import './About.css';
import Hewett from "../../assets/hewett319.png";

function About() {
    return (
        <div className="App main">
            <div className="resume">
                <div className="site-banner-header">
                    <h1 className="resume">
                        About
                    </h1>
                </div>
                
                <div className="container is-max-desktop mb-6">
                    
                    <div className="columns">
                        <div className="column">
                       
                        </div>

                        <div className="about-container">
                            <div>
                                <img src={Hewett} className="clip-circle" alt="Cristen Hewett" />
                                
                                <p  className="has-text-left about">
                                A Front-End Web Developer with expertise and passion to solve difficult problems, 
                                applying significant technical and business experience for building frontend components.
                                </p>
                            </div>
                   
                            <div>

                            <h3>Skills</h3>
                            <div className="skills">
                                <div>CSS</div>
                                <div className="css">
                                                                    <span className="dot"></span>
                                                                    <span className="dot"></span>
                                                                    <span className="dot"></span>
                                                                    <span className="dot"></span>
                                                                    <span className="dot"></span>
                                                                    <span className="dot"></span>
                                                                    <span className="dot"></span>
                                                                    <span className="dot"></span>
                                                                    <span className="opendot"></span>
                                                                    <span className="opendot"></span>
                                                                    </div>

                                <div>HTML</div>
                                <div className=" html">
                                                                        <span className="dot"></span>
                                                                        <span className="dot"></span>
                                                                        <span className="dot"></span>
                                                                        <span className="dot"></span>
                                                                        <span className="dot"></span>
                                                                        <span className="dot"></span>
                                                                        <span className="dot"></span>
                                                                        <span className="dot"></span>
                                                                        <span className="opendot"></span>
                                                                        <span className="opendot"></span>
                                                                    </div>

                                <div>JavaScript</div>
                                    <div className="javascript">
                                                                        <span className="dot"></span>
                                                                        <span className="dot"></span>
                                                                        <span className="dot"></span>
                                                                        <span className="dot"></span>
                                                                        <span className="dot"></span>
                                                                        <span className="dot"></span>
                                                                        <span className="opendot"></span>
                                                                        <span className="opendot"></span>
                                                                        <span className="opendot"></span>
                                                                        <span className="opendot"></span>
                                                                    </div>

                                <div>Adobe Creative Suite</div>
                                <div className="adobe">
                                    <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                    </div>

                                <div>Node JS</div>
                                <div className="node">
                                    <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                    </div>
                                <div>Bootstrap</div>
                                <div className="bootstrap">
                                    <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                    </div>
                                <div>JQuery</div>
                                <div className="jquery">
                                    <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                    </div>
                                <div>Git</div>  <div className="git">
                                    <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                    </div>
                                <div>Microsoft Azure</div>
                                <div className="azure">
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                     <span className="dot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                    </div>
                                <div>Vue.js</div>
                                <div className="vue">
                                    <span className="dot"></span>
                                    <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                    </div>
                                <div>React</div>
                                <div className="react">
                                    <span className="dot"></span>
                                    <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                     <span className="opendot"></span>
                                    </div>
                                </div>
                                </div>
    </div>
    </div>
                </div>
            </div>
        </div>
        );
      }
      
      export default About;
      
